import { render } from "./LiberatedGasComponentChart.vue?vue&type=template&id=36068536"
import script from "./LiberatedGasComponentChart.vue?vue&type=script&lang=js"
export * from "./LiberatedGasComponentChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__